import declare from "dojo/_base/declare";
import New from "csi/table/New";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";

const PromoteSpecialItemController = declare([New, ActionControllerMixin], {
	/**
	 * @override
	 * Promote Special FoodLabelDataSheet Item (ClaimItem / IngredientItem) form - default name initialized from the Library Node Name
	 */
	onCreatePopup: function(view) {
		this.inherited(arguments);

		const foodLabeltemUrl = this.m_urlParent;
		const foodLabeltem = xml.isValidURL(foodLabeltemUrl) ? view.cacheView.getNode(foodLabeltemUrl) : null;
		if (foodLabeltem) {
			view.defView.m_formData.setFieldInitialValue(xml.ATTR_NAME, foodLabeltem.$Name);
		}
	},
});

export = PromoteSpecialItemController;